<template>
<div class="card card-chart">
  <div :class="['card-header', gradientSwitcher(loggedRoleType)]">
    <div :class="{'square-box': type==='doughnut'}">
      <div :class="{'square-content': type==='doughnut'}">
        <doughnut-chart v-if="type==='doughnut'" type="Donut" class="doughnut-chart" :chartData="data" :options="options" />
        <line-chart v-if="type==='line'" type="Line" class="line-chart" :chartData="data" :options="options" />
      </div>
    </div>
  </div>
  <div class="card-content">
    <h4 class="title">{{title}}</h4>
  </div>
  <div v-if="type==='doughnut'" class="card-footer legend-items">
    <div v-for="(item, index) in legendItems" :key="index">
      <div class="square" :style="{ backgroundColor: backgrounds[index] }"/><span>{{ item }}</span>
    </div>
  </div>
  <div class="card-footer">
    <div class="stats">
      <i class="material-icons">access_time</i> {{ period || $t('charts.today') }}
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import DoughnutChart from '@/components/shared/charts/DoughnutChart'
import LineChart from '@/components/shared/charts/LineChart'
import gradientSwitcher from '@/mixins/GradientSwitcher'

const chartTypes = ['doughnut', 'line']

export default {
  name: 'stats-small-card',
  mixins: [gradientSwitcher],
  components: {
    DoughnutChart,
    LineChart
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: function(type) {
        return chartTypes.indexOf(type) > -1
      }
    },
    title: {
      type: String,
      required: true
    },
    legendItems: {
      type: Array
    },
    backgrounds: {
      type: Array
    },
    period: {
      type: String
    },
    data: {},
    options: {}
  },
  computed: {
    ...mapState({
      loggedRoleType: state => state.user.loggedRole.type
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/config.scss';

.card-chart {
  .card-content {
    margin: 0px;
    padding: 20px 17px 8px;
  }

  .title {
    color: $grey;
    margin: 0px;
    padding: 0px;
    line-height: 14px;
    @include normalFontSize();
  }

  .card-footer {
    .stats .material-icons {
      color: $grey;
    }
  }

  .card-footer.legend-items {
    @include smallFontSize();

    .square {
      width: 8px;
      height: 8px;
      border: 1px solid #efefef;
      margin-right: 8px;
    }

    span {
      margin-right: 17px;
    }
  }
}

.square-box {
  position: relative;
  overflow: hidden;
  // background: #4679bd;
}
.square-box:before {
  content: '';
  display: block;
  padding-top: 100%;
}
.square-content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  color: white;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ChartCard.vue